import React, {useRef} from "react";
import {useDispatch} from "react-redux";
import {Button, Form, FormCheck, InputGroup} from "react-bootstrap";
import i18next from "../../../i18n"
import "./yearbookSearchField.scss";
import {setExactSearch, setFacets, setPage, setTerm, setType} from "../../store/yearbook/yearbookSearchSlice";
import FormCheckInput from "react-bootstrap/FormCheckInput";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

const closeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-x-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line></svg>"

const YearbookSearchField = () => {
    const inputRef = useRef(null);

    const [searchTerm, setSearchTerm] = React.useState('');
    const [isExact, setIsExact] = React.useState(false);

    const dispatch = useDispatch();

    const searchTermChanged = (event) => {
        setSearchTerm(event.target.value);
    }
    const clearSearchTerm = () => {
        inputRef.current.value = "";
        setSearchTerm("");
        dispatch(setTerm(""));
        dispatch(setPage(1));
        dispatch(setFacets({}));
    }
    const search = () => {
        dispatch(setTerm(searchTerm));
        dispatch(setPage(1));
        dispatch(setFacets({}));
    }

    const toggleType = () => {
        const ext = !isExact;
        setIsExact(ext);
        dispatch(setExactSearch(ext));
        dispatch(setPage(1));
        dispatch(setFacets({}));
    }

    return (
        <div>
            <InputGroup className={"search-form d-flex flex-row"}>
                <Form.Control
                    ref={inputRef}
                    className={"Search UNODA Yearbooks"}
                    placeholder={i18next.t('yearbook.search', 'Search')}
                    onChange={searchTermChanged}
                    onKeyPress={(event) => {
                        if (event.key === 'Enter') {
                            search();
                        }
                    }}
                />
                <button id="clear-button" hidden={searchTerm.length === 0} onClick={clearSearchTerm}>
                    <span dangerouslySetInnerHTML={{__html: closeIcon}}/>
                </button>
                <Button id="publications-search-btn" variant="primary" onClick={search}>{i18next.t('yearbook.search', 'Search')}</Button>
            </InputGroup>
            <div className={'d-flex flex-row justify-content-end me-4 mt-3'}>
                <FormCheck
                id={'search-type'}
                className={'d-flex flex-row'}
                type={"checkbox"}>
                <FormCheckInput
                    type={"checkbox"}
                    checked={isExact===true}
                    onChange={toggleType} />
                <FormCheckLabel className={'d-flex flex-row justify-content-between w-100'}>
                    Exact phrase
                </FormCheckLabel>
            </FormCheck>
            </div>
        </div>
    );
}

export default YearbookSearchField;
